export default {
	currencySymbol: '$',
	assignmentBilling: {},
	index: {
		welcomeTitle: 'Welcome to findXtra',
		existingUserMessage:
			"If you're already a user, please enter your details below and log-in.",
		newUserMessage:
			"If you're new, tap Register to create a free account to see how findXtra can make your business better.",
		inputs: {
			email: 'Email Address',
			password: 'Password',
		},
		buttons: {
			register: 'Register for a new account',
			forgotPassword: 'Forgot password?',
		},
	},
	registerGate: {
		title: 'Please choose your account type',
		clientAccountTitle: 'Register a Business Client Account',
		clientAccountDesc:
			'I am looking for Outsourced Employees to work for/with me',
		outsourceeAccountTitle: 'Register a Talent Account',
		outsourceeAccountDesc:
			'I am looking to work as an Outsourced Employee and use my knowledge & expertise to help others',
	},
	registerBusiness: {
		title: 'Register for a new findXtra Account',
		inputs: {
			businessName: 'Business name',
			businessNameHint: "Please enter your business' name",
			businessNameError: 'Your business name is required',
			firstName: 'First Name',
			firstNameHint: 'Please enter your name',
			firstNameError: 'Your first name is required',
			surname: 'Surname',
			surnameHint: 'Please enter your surname',
			surnameError: 'Your surname is required',
			email: 'Email address',
			emailHint: 'Please enter your email address',
			emailError: 'Your email address is required',
			emailFormat: 'Please ensure your email address is formatted correctly',
			emailExists: 'A user with that email address already exists',
			invoiceEmail: 'Invoice email address (if different)',
			invoiceEmailHint: 'Alternative email address for invoices',
			addressLine1: 'Address First Line',
			addressLine2: 'Address Second Line',
			addressTown: 'Address Town',
			addressCountry: 'Address Country',
			addressCounty: 'Address County',
			addressPostcode: 'Address Postcode',
			howFound: 'How did you find us?',
			howFoundOptions: {
				google: 'Google Search',
				search: 'Other Search Engines',
				wordOfMouth: 'Word of mouth',
				socialMediaPost: 'Social Media Post',
				socialMediaAdvert: 'Social Media Advert',
				blog: 'Blog or Publication',
				email: 'Email Marketing',
				phone: 'Telephone',
				radio: 'Radio',
				tv: 'TV',
			},
			newsletterSignup: 'Subscribe to monthly newsletter?',
			password: 'Password',
			passwordHint: 'Please set your password',
			passwordError: 'A password is required',
			confirmPassword: 'Repeat password',
			confirmPasswordHint: 'Please repeat your password',
			confirmPasswordError: 'Please re-enter your password to confirm',
			passwordMismatchError: 'Your passwords did not match',
			privacyLabel: 'Please toggle this to show you agree to our',
			privacyButtonLabel: 'privacy policy',
			privacyToggleError:
				'You must agree to our privacy policy to register an account',
			termsLabel: 'Please toggle this to show you agree to our',
			termsButtonLabel: 'terms and conditions',
			termsToggleError:
				'You must agree to our terms and conditions to register an account',
		},
		privacyPolicyTitle: 'Privacy Policy',
		termsAndConditionsTitle: 'Terms And Conditions',
		registrationCompleteTitle: 'Registration complete',
		registrationCompleteInfo:
			'Your new findXtra account has been created, you can now log-in',
	},
	registerOutsourcee: {
		accountCreated: {
			title: 'Account Created',
			firstLine:
				"Your Talent journey has just begun! We can't wait to have you join us.",
			secondLine:
				'Your account & login with us has been created, so if you need to come back to your application later you can log-in at any time to resume your application!',
			thirdLine:
				'The whole findXtra team wishes you luck with your application!',
		},
		title: 'Register for a new Talent Account',
		yourDetails: 'Your Details',
		defaultQuestions: {
			firstname: 'First name',
			surname: 'Surname',
			email: 'Email',
			firstLine: 'First Line Of Address',
			secondLine: 'Second Line Of Address',
			town: 'Town',
			country: 'Country',
			county: 'County / State',
			postcode: 'Postcode',
			vat: 'Are you VAT registered?',
			vatNumber: 'VAT Number',
			password: 'Password',
			confirmPassword: 'Confirm Password',
			errors: {
				firstname: 'Firstname is required',
				surname: 'Surname is required',
				email: 'Email is required',
				emailFormat: 'Please ensure the email address is formatted correctly',
				firstLine: 'First line of address is required',
				secondLine: 'Second line of address is required',
				town: 'Town is required',
				country: 'Country is required',
				county: 'County is required',
				postcode: 'Postcode is required',
				password: 'Please enter a password',
				passwordMismatch: 'Your passwords do not match',
			},
		},
		services: {
			title: 'Services',
			introFirstLine: 'Select all services you wish to offer',
			introSecondLine:
				'If you are returning to complete your application, your previous answers will have been saved - you need only reselect your chosen field(s) of service and click Next',
			rate: 'What hourly rate do you charge for this service?',
			firstFiveWeekDiscount:
				'What percentage (if any) would you be willing to discount your first 5 weeks?',
			twelveHourDiscount:
				'What percentage (if any) would you discount your pay for a role above 12hrs p/wk?',
			visibleToClients: 'This answer will be visible to clients',
		},
	},
	mainLayout: {
		navigation: {
			dashboard: 'Dashboard',
			availability: 'Availability',
			noAvailability: 'No availability set',
			assignments: 'Assignments',
			outsourceeDirectory: 'Talent Directory',
			billingCentre: 'Billing Centre',
			termsAndConditions: 'Terms & Conditions',
			opsRulesPerks: 'Ops Rules & Perks',
			privacyPolicy: 'Privacy Policy',
			assignmentsNeedingBilling: 'Assignments Needing Billing',
			draftAssignments: 'Draft Assignments',
			clientDirectory: 'Client Directory',
			admin: 'Admin',
			clientTermsAndConditions: 'Client Terms & Conditions',
			outsourceeTermsAndConditions: 'Talent Terms & Conditions',
			outsourceeOpsRulesAndPerks: 'Talent Ops Rules & Perks',
			logout: 'Log-out',
		},
	},
	dashboard: {
		toolbarTitle: 'Dashboard',
		noAssignments:
			"You don't have any assignment currently, get started by finding your first talent",
		welcomeTitle: 'Welcome to findXtra',
		itIsCurrently: 'It is currently',
		week: 'Week',
		welcomeModalOutsourcee: [
			"Your findXtra journey has just begun! We can't wait to have you join us and start working with your chosen client(s)!",
			"You'll have received a message from your Talent Manager (TM) - they will be there to help you in any way you need and answer any questions you may have.",
			'The whole findXtra team wishes you luck with your Talent journey!',
		],
		welcomeModalClient: [
			"Your findXtra journey has just begun! We can't wait to have you join us and start working with your chosen Talent(s)!",
			"You'll have received a message from your Customer Success Manager (CSM) - they will be there to help you in any way you need and answer any questions you may have.",
			'The whole findXtra team wishes you luck with your outsourcing journey!',
		],
		checklistTitle: 'Talent Checklist',
		checklistDescription:
			"Here's the remaining steps you need to take to complete your Talent registration and set your account active.",
		checklist: {
			profilePicture: 'Profile Picture',
			profilePictureDesc:
				'Upload a profile picture so clients can get to know you',
			elevatorPitch: 'Elevator Pitch',
			elevatorPitchDesc:
				'Upload an elevator pitch so clients can get to know you',
			proofOfId: 'Proof of ID',
			proofOfIdDesc: 'Provide proof of ID',
			proofOfAddress: 'Proof of address',
			proofOfAddressDesc: 'Provide proof of address',
			bankDetails: 'Bank details',
			bankDetailsDesc: 'Provide your bank details',
			liabilityInsurance: 'Liability Insurance',
			liabilityInsuranceDesc:
				'Provide proof of Liability Insurance, or skip for later',
			indemnityInsurance: 'Indemnity Insurance',
			indemnityInsuranceDesc:
				'Provide proof of Indemnity Insurance, or skip for later',
			cyberInsurance: 'Cyber Insurance',
			cyberInsuranceDesc: 'Provide proof of Cyber Insurance, or skip for later',
			speedTest: 'Speed Test',
			speedTestDesc: 'Upload your speed test results',
			opsRulePerks: 'Ops Rules Perks',
			opsRulePerksDesc: 'Please sign our Ops, Rules & Perks',
			termsAndConditions: 'Terms and Conditions',
			termsAndConditionsDesc: 'Please sign our Terms and Conditions',
			skipHint:
				'You will need these insurances before you can be offered assignments',
			skippedTitle: 'Skipped',
			skipped: 'You can provide this to your Talent Manager later',
			rejected: 'This item was rejected, please re-submit',
			renewalDate: 'Renewal Date',
			renewalHint: 'This is the date that the insurance expires',
			saveDate: 'Save date',
			renewalDateSaved: 'Renewal date saved',
			complete:
				'All sections completed, please wait for your Talent Manager to review and approve your application',
		},
		outsourceeActivity: 'Talent Activity',
		noActivity: 'No activity yet!',
	},
	profile: {
		newSubAccountModal: {
			title: 'New Sub Account',
			firstName: 'First Name',
			surname: 'Surname',
			email: 'Email',
			password: 'Password',
			confirmPassword: 'Confirm Password',
		},
		title: 'Profile',
		edit: {
			picRequirementsTitle: 'Your picture MUST be:',
			picRequirementsOne: [
				'Taken via webcam',
				'Clear and in focus',
				'In colour',
				'Unaltered by computer software or filters',
				'Contain no other people',
			],
			picRequirementsTitleTwo: 'You MUST',
			picRequirementsTwo: [
				'Be facing forwards and looking straight at the camera',
				'Have a friendly & approachable expression',
				'Have your eyes open and visible',
				'Not have hair in front of your eyes',
				"Not have a head covering (unless it's for religious or medical reasons)",
				'Not have anything covering your face',
				'Not have any shadows or glare on your face',
				'Be wearing attire you believe would be appropriate for work or a job interview',
			],
			replaceAvatar: 'Replace profile photo',
			replaceAvatarHint: 'Leave blank to keep as it',
			replaceAvatarLabel: 'Profile Picture',
			firstname: 'First Name',
			surname: 'Surname',
			defaultAddress: 'Default Address',
			invoiceAddress: 'Invoice Address',
			addressLine1: 'First Line Of Address',
			addressLine2: 'Second Line Of Address',
			town: 'Town',
			county: 'County',
			country: 'Country',
			postcode: 'Postcode',
			vat: 'Are you VAT Registered?',
			vatNumber: 'VAT Number',
			invoiceEmail: 'Invoice Email',
			businessName: 'Business Name',
		},
		services: {
			title: 'Talent Services',
			offered: 'Service Offered?',
			omHint: 'Your Talent Manager will set this',
			rate: 'What hourly rate do you charge for this service?',
			onSite:
				'Are you willing to work on-site for this service? (You will only be matched by county/state)',
			onSitePercent: 'What % increase do you wish to add for on-site work?',
			priceCalc: 'This would lead to the rate being',
			pendingNotice: 'Pending changes (awaiting Talent Manager approval)',
			rateChange: 'Rate changed to:',
			onSiteChange: 'On-site changed to:',
			surchargeChange: 'Surcharge changed to:',
		},
		subAccounts: {
			title: 'Sub Accounts',
			addAccount: 'Add Account',
			hint: 'Here you can create additional accounts for your business to access findXtra',
			noAccounts: 'No sub accounts currently',
			canAccessChats: 'Can access Chats',
			canManageAssignments: 'Can manage Assignments',
			canAccessDirectory: 'Can access Directory and request new Assignments',
			canManageSub: 'Can manage sub Accounts',
			canAccessBilling: 'Can access billing centre',
		},
		deleteAccount: {
			title: 'Delete Account',
			info: [
				'Warning, deleting your account is irreversable and will delete:',
				'All uploaded files / media (profile picture e.t.c.)',
				'All chats',
				'All sub-accounts (if applicable)',
				'All active assignments must be terminated in order to delete your account',
			],
			buttonLabel: 'Delete account',
			confirmButton: 'Confirm account deletion',
		},
	},
	elevatorPitch: {
		title: 'Elevator Pitch',
		hint: 'Upload an elevator pitch so that clients can get to know you and learn more about your services.',
		videoRequirementsOneTitle: 'Your video MUST be:',
		videoRequirementsOne: [
			'Taken via webcam',
			'Clear and in focus',
			'In colour',
			'Unaltered by computer software or filters',
			'Contain no other people',
		],
		videoRequirementsTwoTitle: 'You MUST:',
		videoRequirementsTwo: [
			'Be facing forwards and looking straight at the camera',
			'Have a friendly & approachable expression',
			'Have your eyes open and visible',
			'Not have hair in front of your eyes',
			"Not have a head covering (unless it's for religious or medical reasons)",
			'Not have anything covering your face',
			'Not have any shadows or glare on your face',
			'Be wearing attire you believe would be appropriate for work or a job interview',
			'Only refer to your first name and do not include your last name',
			'Not mention any alternative contacts details',
			'Not mention personal information',
			'Not mention sensitive data about you or past employers',
		],
		videoRequirementsThreeTitle:
			'To help to create a successful video we SUGGEST you:',
		videoRequirementsThree: [
			'Have a plain or uncluttered light-coloured background',
			'Write down bullet points of what you want to say',
			'If you decide to write a word-for-word script, try not to come accross robotic and try to continue to look at the camera where you can',
			"Keep an arm's length between you and the screen",
			'Rewatch the video at least once to make sure you are happy with it',
		],
		videoRequirementsFourTitle: 'Talk about:',
		videoRequirementsFour: [
			'Who you are',
			'A short snipped about you personally',
			'What you do for a living &/or profession',
			'Your experience',
			'Your strengths',
			'The past results of your work',
			'The past challenges you have faced',
			'How you achieve the result you get',
			'Try to be memorable (within reason)',
			'Let your personality show in the video',
		],
		uploadedNotice: 'Elevator pitch uploaded',
	},
	proofs: {
		id: {
			hint: 'Provide 1 form of ID (Passport / Driving Licence)',
			title: 'Proof of ID',
			info: 'Upload proof of ID, which is required for right-to-work checks. Your ID is uploaded via HTTPS and will be deleted once we have performed our right-to-work checks.',
		},
		address: {
			hint: 'Provide 1 proof of address (Utility Bills, Credit Card Statements, Bank Statements & Lease Agreements)',
			title: 'Proof of Address',
			info: 'Upload proof of address, which is required for our right-to-work checks.',
		},
		bankDetails: {
			hint: 'Please provide your bank details. These are saved via HTTPS and will be deleted once we confirm their validity.',
			title: 'Bank Details',
			acc: 'Account Number',
			sort: 'Sort Code',
		},
		liabilityInsurance: {
			hint: 'Provide proof of insurance. Popular insurance providers include PolicyBee & Hiscox',
			title: 'Proof of Liability Insurance',
			info: 'Upload proof of liability insurance. This is required to work with our clients.',
		},
		indemnityInsurance: {
			hint: 'Provide proof of insurance. Popular insurance providers include PolicyBee & Hiscox',
			title: 'Proof of Indemnity Insurance',
			info: 'Upload proof of indemnity insurance. This is required to work with our clients.',
		},
		cyberInsurance: {
			hint: 'Provide proof of insurance. Popular insurance providers include PolicyBee & Hiscox',
			title: 'Proof of Cyber Insurance',
			info: 'Upload proof of cyber insurance. This is required to work with our clients.',
		},
		speedTest: {
			hint: 'Run & provide your Wi-Fi Speed Results (an adequate tool can be found on speedtest.net)',
			title: 'Speed test',
			info: 'Upload your speed results.',
		},
		uploadedNotice: 'Proof Uploaded',
		bankDetailsUploaded: 'Bank details saved',
		bankDetailsError: 'Error saving bank details',
	},
	sign: {
		opsRulesPerks: {
			hint: 'Read & Sign if you agree & understand. If you have questions, feel free to contact your Talent Manager.',
			title: 'Ops Rules & Perks',
			accept: 'I accept the ops rules and perks',
		},
		termsAndConditions: {
			hint: 'Read & Sign if you agree & understand. If you have questions, feel free to contact your Talent Manager.',
			title: 'Terms and Conditions',
			accept: 'I accept the terms and conditions',
		},
		nameFieldLabel: 'Name',
		nameErr: 'You must input your name to continue',
		error: 'You must accept this in order to proceed',
		signedNotice: 'Policy signed',
	},
	availability: {
		daysUnavailableModal: {
			title: 'Book days off',
			notice: 'You must communicate days off to all of your active client(s)',
		},
		title: 'Availability',
		hint: 'Use the controls below to set your availability',
		hide: 'Hide from directory',
		hideHint:
			'Setting yourself hidden means you will not show in the directory when clients search, and acts as a way to toggle your overall availability if you have no availability.',
		unhide: 'Unhide from directory',
		unhideHint:
			'Un-hiding your profile will make you able to receive assignment requests again',
		totalAvailability: 'Total Availability:',
		days: [
			'Monday',
			'Tuesday',
			'Wednesday',
			'Thursday',
			'Friday',
			'Saturday',
			'Sunday',
		],
		amStart: 'AM Start',
		amEnd: 'AM End',
		pmStart: 'PM Start',
		pmEnd: 'PM End',
		total: 'Total',
		bookDaysOff: 'Book days off',
	},
	assignments: {
		activeAssignments: 'Active Assignments',
		noAssignments: 'No assignments currently',
		tasks: 'Tasks:',
		modificationsRequested: 'Modifications requested',
		terminationRequested: 'Termination requested',
		inactiveAssignments: 'Inactive Assignments',
		noInactiveAssignments: 'No inactive assignments currently',
		awaitingCSMApproval: 'Awaiting CSM approval',
		changesRequested: 'Changes requested, CSM reviewing',
		assignmentRejected: 'Assignment rejected by Talent',
		awaitingOutsourcee: 'Awaiting Talent response',
		withBillingManager: 'With Billing Manager',
		reviewButton: 'Review',
		archivedAssignments: 'Archived Assignments',
		noArchivedAssignments: 'No archived assignments',
		tasksAndTimes: 'Tasks & Times',
		workSchedule: 'Work Schedule',
		newTask: {
			title: 'New Task',
			name: 'Name',
			description: 'Description',
			error: 'Task name is required',
		},
	},
	directory: {
		title: 'Talent Directory',
		noOutsourcees: 'No Talent match your search',
		info: {
			title: 'Despite your chosen & assigned Weekly Hours:',
			below: '',
			belowNote:
				'All recorded hours below your chosen Weekly Hours are reimbursed on your next invoice.',
			above: '',
			aboveNote:
				'All recorded hours over your Weekly Hours need approval and will be added to your next invoice.',
			note: 'Your chosen Weekly Hours can also be adjusted anytime',
		},
		newAssignment: {
			yourOutsourcee: 'Your Talent',
			totalHoursAvailable: 'Total Hours Available',
			weeklyHoursRequired: 'Weekly Hours Required',
			assignmentType: 'Assignment type',
			assignmentTypes: {
				fullRemote: 'Full-remote',
				hybrid: 'Hybrid',
				onSite: 'Full on-site',
			},
			address: 'Address for on-site work',
			addressErr: 'Please input the address for on-site work',
			hoursOnSite: 'Hours spent on-site',
			hoursSuffix: ' Hours p/wk',
			monthlyCost: 'Monthly cost',
			perHour: 'per hour',
			remote: 'Remote:',
			onSite: 'On-site:',
			roleDetails: 'Role Details',
			workSchedulePref: 'Work Schedule Preference',
			workScheduleNote:
				'If you have a preference for when your Talent works, use the section below',
			workScheduleSettings: 'Work Schedule Settings',
			fixedHoursNote: [
				'If Fixed Hours is enabled, you are stating specific hours your Talent must work. If disabled, they can work any time within these hours.',
				'If a day is not marked as active then your Talent will not work that day.',
				'* Please note - Talent appreciate as much flexibility as they can get.',
			],
			day: 'Day',
			active: 'Active?',
			start: 'Start',
			end: 'End',
			fixed: 'Fixed Hours',
			fixedQ: 'Fixed Hours?',
			days: {
				Monday: 'Monday',
				Tuesday: 'Tuesday',
				Wednesday: 'Wednesday',
				Thursday: 'Thursday',
				Friday: 'Friday',
				Saturday: 'Saturday',
				Sunday: 'Sunday',
			},
			hoursExceeded:
				'Your set hours go beyond the time requested, please adjust the time required to match the hours set',
			preferredStartDate: 'Preferred Start Date',
			startDateHint:
				'If you have a specific date you would like the assignment to begin, use the section below',
			startDate: 'Start Date',
			notice: 'Contracted notice period',
			noticeNote:
				'Per our Terms & Conditions, this notice period is a legally binding commitment for both the Client and the Talent and must be adhered to once it has been agreed.',
			noticeLabel: 'Notice Period (weeks)',
			sendAssignment: 'Send Assignment Request',
		},
		manageAssignment: {
			title: 'Manage Talent -',
			lastLogin: 'Last login:',
			registration: 'Registration',
			profile: 'Profile',
			registrationForm: 'Talent Registration Form',
			approveInitialApplication: 'Approve Initial Application',
			outsourceeChecklist: 'Talent Checklist',
		},
		viewProfile: {
			availability: 'Availability:',
			totalHoursAvailable: 'Total Hours Available:',
			byDay: 'Availability by day',
			day: 'Day',
			am: 'AM',
			pm: 'PM',
			total: 'Total',
			unavailable: 'Talent unavailable this day',
			daysBookedOff: 'Days Booked Off:',
			availableServices: 'Available Services:',
			onSiteAvailable: 'Available for on-site work',
			adjustTime: '(Use the slider below to adjust your time requirements)',
			monthlyPricePerHour: 'Monthly Price per Weekly Hour:',
			equivalentTo: 'Equivalent to',
			phr: 'p/hr',
			basedOn: 'Based on your search',
			hrspwk: 'hr(s) p/wk',
			perMonth: 'per month',
			hrsPerMonth: 'hrs per month',
			newAssignment: 'New Assignment',
			noAvailability: 'This outsourcee has no availability',
			firstMonthDiscount: 'First Month Discount',
			fmdNote:
				'This Talent offers a percentage discount for your first month / 4 weeks',
			twelveHourDiscount: '12h Discount',
			thdNote:
				'This Talent offers a discount for assignments over 12 hours per week',
			information: 'Information:',
			onSiteNote:
				'This Talent is happy to work on-site for this service in their county / state',
			onSiteSurcharge: 'On-site surcharge:',
			mppwh: 'Monthly Price per Weekly Hour:',
			getToKnow: 'Get to know',
			hoursPerWeek: 'Hours Per Week',
			managementOptions: 'Management Options',
			insurance: 'Insurance renewal dates',
			showPending: 'Show pending',
			showActive: 'Show active',
			showInactive: 'Show inactive (4wk)',
		},
		managementNotes: {
			indemnityRenewal: 'Indemnity Renewal:',
			liabilityRenewal: 'Liability Renewal:',
			cyberRenewal: 'Cyber Renwal:',
			pendingApproval: 'Pending approval',
			recentChecklist: 'Recently completed checklist step',
			outsourceeFormUpdate: 'Talent Form Updated',
			liabilityNotProvided: 'Liability Insurance not provided',
			indemnityNotProvided: 'Indemnity Insurance not provided',
			cyberNotProvided: 'Cyber Insurance not provided',
			inactive: 'Not logged in for 4 weeks',
			managementOptions: 'Management Options',
			manageOutsourcee: 'Manage Talent',
			manageOm: 'Manage OM',
			billingCentre: 'View Billing Centre',
			assignments: 'View Assignments',
		},
	},
	ratingComponent: {
		error: 'Error fetching rating',
		rating: 'Rating:',
		newOutsourcee: 'New Talent',
	},
	billingCentre: {
		week: 'Week',
		timeRequested: 'Time Requested:',
		hours: 'hours(s)',
		timeExceeded:
			'You have exceeded your Assignment weekly hours - please make sure you have received authorisation via email/message',
		editClientRating: 'Edit client reating',
		rateClient: 'Rate client',
		timeRequested: 'Time Requested:',
		editRating: 'Edit Rating',
		leaveRating: 'Leave Rating',
		total: 'Total:',
		earnings: 'Earnings:',
		cost: 'Cost:',
		earningsSubtotal: 'Earnings Subtotal:',
		costSubtotal: 'Cost Subtotal:',
		vat: 'VAT',
		addAdjustments: 'Add Adjustments',
		removeStandaloneAdjustment: 'Remove standalone adjustment',
		removeRecurringAdjustment: 'Remove recurring adjustment',
		earningsTotal: 'Earnings Total:',
		costTotal: 'Cost Total:',
		signOffTimesheet: 'Sign off timesheet & generate invoice',
		downloadInvoice: 'Download invoice',
		raiseDispute: 'Raise Dispute',
		disputeRaised: 'Dispute Raised',
		resolveDispute: 'Mark Resolved',
	},
	assignmentComponent: {
		for: 'for',
		overviewTitle: 'Overview',
		tasksTitle: 'Tasks',
		scheduleTitle: 'Schedule',
		termination: 'Termination',
		roleDetails: 'Role Details',
		editRoleDetails: 'Edit role details',
		clientAndOutsourcee: 'Client & Talent',
		client: 'Client',
		outsourcee: 'Talent',
		weeklyTimeRequested: 'Weekly Time Requested',
		hours: 'Hour(s)',
		changeTo: 'Change to',
		onSiteWorking: 'On-site working',
		onSiteWorkingQ: 'On site working?',
		hybridWorkingQ: 'Hybrid working?',
		hoursOnSite: 'Hours on site',
		pwk: 'p/wk',
		onSiteAddress: 'Address for on-site work',
		earnings: 'Estimated Monthly Earnings',
		cost: 'Estimated Monthly Cost',
		earningsCost: 'Estimated Monthly Earnings(Talent) / Cost(Client)',
		noticePeriod: 'Notice Period',
		weeks: 'Week(s)',
		noticeRequested: 'Notice Period requested?',
		schedule: {
			title: 'Work schedule',
			settings: 'Work schedule settings',
			notice:
				"If 'fixed hours' is toggled, this means work should completed during the hours specified, otherwise work can be carried out during any timespan provided.",
			noticeOutsourcee:
				"If 'Fixed Hours' is toggled, this means the client is requesting that you work the hours specified, otherwise you can use your time during any timespan provided.",
			day: 'Day',
			active: 'Active?',
			start: 'Start',
			end: 'End',
			fixed: 'Fixed Hours?',
			hoursExceeded:
				'Your set hours go beyond the time requested, please adjust the time requested to match the hours set.',
			noSchedule: 'No schedule Preference',
			startDate: 'Preferred Start Date',
			changes: 'Work Schedule Changes',
			noStartDate: 'No preferred start date',
		},
		tasks: {
			title: 'Tasks',
			addTask: 'Add Task',
			addOnSiteTask: 'Add on-site task',
			remote: 'Remote',
			onSite: 'On-site',
			description: 'Description:',
			startTimer: 'Start Activity Timer',
			timerRunning: 'A timer is currently running',
			manualTime: 'Manually Add Time',
			archiveTask: 'Archive Task',
			archivedTasks: 'Archived Tasks',
			logged: ['Logged', 'against this task'],
		},
		footer: {
			cancelChanges: 'Cancel Changes',
			requestChanges: 'Request Changes',
			approveChanges: 'Approve Changes',
			approve: 'Approve Assignment',
			reject: 'Reject',
			activateDraft: 'Activate draft assignment',
			terminate: 'Terminate assignment',
			changesRequested:
				'Changes have been requested and your CSM is currently reviewing',
			editChanges: 'Edit Changes',
			rejectChanges: 'Reject Changes',
			assignmentRejected: 'Assignment Rejected',
			reason: 'Reason:',
			archived: 'Assignment Archived',
			terminated: 'Assignment Terminated',
		},
	},
	assignmentBilling: {
		title: 'Assignments',
		noAssignments: 'No assignments currently',
		service: 'Service:',
		business: 'Business:',
		outsourcee: 'Talent:',
		email: 'Email:',
		invoiceEmail: 'Invoice Email:',
		tasks: 'Tasks:',
		viewDetails: 'View Details',
		activate: 'Activate Assignment (confirm billing)',
	},
	clientDirectory: {
		assignmentsCount: 'Assignments:',
		assignments: 'Assignments',
		viewProfile: 'View Profile',
		manageCSM: 'Manage CSM',
		subAccounts: 'Sub Accs',
		billingCentre: 'Billing Centre',
		csmModal: {
			title: 'Manage CSM for',
			current: 'Current CSM',
			clients: 'Number of clients:',
			new: 'Assign new CSM',
		},
	},
	buttonLabels: {
		back: 'Back',
		login: 'Login',
		next: 'Next',
		reportIssue: 'Report issue',
		edit: 'Edit',
		cancel: 'Cancel',
		cancelChanges: 'Cancel Changes',
		action: 'Action',
		proceedWithout: 'Proceed without',
		sign: 'Sign',
		save: 'Save',
		saveChanges: 'Save Changes',
		confirm: 'Are you sure?',
		view: 'View',
		archive: 'Archive',
	},
	errors: {
		server: ' Error communicating with server',
		file: ' File upload failed',
	},
	days: {
		Monday: 'Monday',
		Tuesday: 'Tuesday',
		Wednesday: 'Wednesday',
		Thursday: 'Thursday',
		Friday: 'Friday',
		Saturday: 'Saturday',
		Sunday: 'Sunday',
	},
};
